var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.item.type,{tag:"Component",attrs:{"item":_vm.item,"reverse":_vm.reverse}})}
var staticRenderFns = []

export { render, staticRenderFns }